<div id="dashboard" class="library-shell" [class.library-shell--wood]="isWoodPresentation" [class.mobile-ui]="isMobilePresentation" [class.library-shell--mobile]="isMobilePresentation" [class.library-shell--web]="isWebPresentation">
  @if (isWoodPresentation) {
    <aside class="library-sidebar" aria-label="Navegación principal">
      <div class="library-sidebar__identity">
        <a class="library-sidebar__avatar" routerLink="profile" routerLinkActive="is-active" matTooltip="Perfil" matTooltipClass="tt-accent">
          <img [src]="profileImageUrl" alt="Foto de perfil" (error)="handleProfileImageError($event)">
        </a>
      </div>
      <nav class="library-sidebar__nav">
        <span class="library-sidebar__divider" aria-hidden="true"></span>
        <a routerLink="books" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }" matTooltip="Mi colección" matTooltipClass="tt-accent" aria-label="Biblioteca"><mat-icon>view_module</mat-icon><span class="library-sidebar__label">Biblioteca</span></a>
        <a routerLink="catalog" routerLinkActive="is-active" matTooltip="Catálogo global" matTooltipClass="tt-accent" aria-label="Catálogo"><mat-icon>travel_explore</mat-icon><span class="library-sidebar__label">Catálogo</span></a>
        <span class="library-sidebar__divider" aria-hidden="true"></span>
        <a routerLink="statistics" routerLinkActive="is-active" matTooltip="Estadísticas" matTooltipClass="tt-accent" aria-label="Estadísticas"><mat-icon>bar_chart</mat-icon><span class="library-sidebar__label">Estadísticas</span></a>
        @if (isCapabilityActive('feed')) {
          <a routerLink="community" routerLinkActive="is-active" matTooltip="Comunidad" matTooltipClass="tt-accent" aria-label="Comunidad"><mat-icon>diversity_3</mat-icon><span class="library-sidebar__label">Comunidad</span></a>
        }
        @if (isCapabilityActive('chat')) {
          <button type="button" (click)="openChat()" matTooltip="Chat" matTooltipClass="tt-accent" aria-label="Abrir chat"><mat-icon>forum</mat-icon><span class="library-sidebar__label">Mensajes</span></button>
        }
        @if (isCapabilityActive('notificaciones')) {
          <app-notification-bell placement="sidebar"></app-notification-bell>
        }
      </nav>
      <div class="library-sidebar__bottom">
        @if (canModerateCatalog && canUseDesktopAdministration) {
          <a routerLink="adminpanel" routerLinkActive="is-active" matTooltip="Administración" matTooltipClass="tt-accent" aria-label="Administración"><mat-icon>admin_panel_settings</mat-icon><span class="library-sidebar__label">Administración</span></a>
        }
        @if (pwa?.canInstall()) {
          <button type="button" (click)="installApp()" matTooltip="Instalar aplicación" matTooltipClass="tt-accent" aria-label="Instalar aplicación"><mat-icon>install_desktop</mat-icon><span class="library-sidebar__label">Instalar aplicación</span></button>
        }
        <a routerLink="/home" (click)="logout()" matTooltip="Cerrar sesión" matTooltipClass="tt-accent" aria-label="Cerrar sesión"><mat-icon>logout</mat-icon><span class="library-sidebar__label">Cerrar sesión</span></a>
      </div>
    </aside>
  } @else if (isWebPresentation) {
    <!-- Diferido: la navegación Web no pesa en la carga inicial mientras la presentación no esté activa. -->
    @defer {
    <app-web-navigation [userName]="displayName" [imageUrl]="profileImageUrl"
      [communityEnabled]="isCapabilityActive('feed')" [chatEnabled]="isCapabilityActive('chat')"
      [unreadChatCount]="(unreadChatCount$ | async) ?? 0" [canAdministrate]="canModerateCatalog && canUseDesktopAdministration"
      [notificationsEnabled]="isCapabilityActive('notificaciones')"
      (imageError)="handleProfileImageError($event)" (logoutRequested)="logoutAndLeave()"></app-web-navigation>
    <app-web-reading-window></app-web-reading-window>
    }
  } @else {
    <app-mobile-dashboard-chrome [title]="pageTitle" [user]="userData" [imageUrl]="profileImageUrl"
      [notificationsEnabled]="isCapabilityActive('notificaciones')" [communityEnabled]="isCapabilityActive('feed')"
      [chatEnabled]="isCapabilityActive('chat')" [unreadChatCount]="(unreadChatCount$ | async) ?? 0"
      (imageError)="handleProfileImageError($event)"
      (chatRequested)="openChat()"></app-mobile-dashboard-chrome>
  }

  <main class="library-main">
    <section class="library-content">
      @if (realtimeStatus$ | async; as realtimeStates) {
        @if (hasRealtimeNotice(realtimeStates)) {
          <aside class="library-connection" [class.library-connection--offline]="isOffline(realtimeStates)" role="status" aria-live="polite">
            <mat-icon>{{isOffline(realtimeStates) ? 'wifi_off' : 'sync'}}</mat-icon>
            <span>{{realtimeMessage(realtimeStates)}}</span>
            <button type="button" (click)="retryRealtime()">Reintentar ahora</button>
          </aside>
        }
      }
      @if (moderationAccess$ | async) {
        @if (accountRestrictionMessage(); as restriction) {
          <aside class="library-connection library-connection--offline" role="alert">
            <mat-icon>gpp_bad</mat-icon>
            <span>{{restriction}} Las funciones restringidas se han detenido; tu biblioteca y sesión continúan disponibles.</span>
          </aside>
        }
      }
      <app-user-router></app-user-router>
      <!-- Solo lo ven cuentas nuevas: se carga aparte para no pesar en el arranque. -->
      @defer (on idle) { <app-theme-onboarding></app-theme-onboarding> }
      @if (isWoodPresentation || isWebPresentation) {
        <app-floating-window-host></app-floating-window-host>
      }
      @if (isWoodPresentation) {
        <app-web-reading-window></app-web-reading-window>
      }
    </section>
  </main>
</div>
